module.exports = __webpack_public_path__ + "img/happy_bday_clipart_2.5364f3b6.jpg";